

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <PassChange></PassChange>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import PassChange from '@/components/auto_register/gestion/PassChange.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    PassChange
    
  },

  methods: {

}

}
    

</script>


